import type { components } from "@/api-schema";
import { JobFunctionIdentifierSystem } from "@/api-schema-enums";
import { normalizePositiveSafeIntegerIdentifier } from "@/common/helpers/normalize-numeric-identifier";

type JobFunction = Pick<components["schemas"]["JobFunction"], "jobFunctionIdentifiers">;
type JobFunctionIdentifierDto = components["schemas"]["JobFunctionIdentifierDto"];

export function getJobFunctionV1Identifier(jobFunction: JobFunction): string | undefined {
  return jobFunction.jobFunctionIdentifiers?.find((identifier) => identifier.type === JobFunctionIdentifierSystem.V1)
    ?.identifier;
}

export function toJobFunctionIdentifierDtos(v1Identifier: string): JobFunctionIdentifierDto[] {
  const normalizedIdentifier = normalizePositiveSafeIntegerIdentifier(v1Identifier);
  return normalizedIdentifier === undefined
    ? []
    : [{ type: JobFunctionIdentifierSystem.V1, identifier: normalizedIdentifier }];
}
